module.exports = __webpack_public_path__ + "img/20180303_123313-1.98de6e9c.jpg";